import { useMemo } from 'react';
import styled from 'styled-components';

import { ScrollArea, utils } from '@desygner/ui-common-components';

import { ExternalShareGroup } from '../ShareAccess.types';
import { GroupExternalShare } from './GroupExternalShare';

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.MediumLarge)};
  padding: ${({ theme }) => utils.rem(theme.Spacing.Size.XXSmall)};
  overflow-y: auto;
`;

export type ExternalShareProps = {
  groups: ExternalShareGroup[];
  onItemClick: (data: { groupId: string; itemId: string }) => void;
};

export function ExternalShare({ groups, onItemClick }: ExternalShareProps) {
  const MIN_HEIGHT = 218;
  const MAX_HEIGHT = 362;

  const dynamicHeight = useMemo(() => {
    const groupCount = groups.length;

    if (groupCount === 0) return MIN_HEIGHT;

    if (groupCount === 1) return MIN_HEIGHT;

    const heightRange = MAX_HEIGHT - MIN_HEIGHT;
    const heightPerGroup = heightRange / 3;

    const calculatedHeight = MIN_HEIGHT + (groupCount - 1) * heightPerGroup;

    return Math.min(Math.max(calculatedHeight, MIN_HEIGHT), MAX_HEIGHT);
  }, [groups.length]);

  return (
    <ScrollArea style={{ height: utils.rem(dynamicHeight) }}>
      <StyledWrapper>
        {groups.map((group) => (
          <GroupExternalShare
            key={group.id}
            group={group}
            onItemClick={(itemId) => {
              onItemClick({
                groupId: group.id,
                itemId,
              });
            }}
          />
        ))}
      </StyledWrapper>
    </ScrollArea>
  );
}
